var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFleet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    width: 72,
    height: 72,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    d: "M36,0A36,36,0,1,0,72,36,36.041,36.041,0,0,0,36,0m0,67.436A31.436,31.436,0,1,1,67.436,36,31.472,31.472,0,0,1,36,67.436",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    d: "M78.154,28.03l-6.361,5.9L58.048,32.808l-1.681,1.665L67.4,38.978l-3.51,4.373-5.952.02-1.465,1.451,5.249,2.041,1.992,5.268,1.465-1.451.076-5.952,4.406-3.468,4.4,11.077,1.681-1.664L74.75,36.916l5.962-6.3c1.013-1,1.492-3.038,1.045-3.593-.552-.452-2.59.008-3.6,1.011",
    transform: "translate(-24.211 -11.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    d: "M54.2,62.152h0v0Z",
    transform: "translate(-23.279 -26.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    d: "M26.959,54.854l8.517.209a.723.723,0,0,0,.734-.711v-.023c0-.385,0-.558,0-.592l-.023-.229-.2.131a1.187,1.187,0,0,1-.615.162c-.256,0-4.159.095-7.533.177a14.35,14.35,0,0,0,2.988-4.236A1.533,1.533,0,0,0,30.766,48a1.526,1.526,0,0,0-1.74-.058,14.563,14.563,0,0,0-4.391,3.137l.192-7.783a.722.722,0,0,0-.711-.733h-.024c-.387,0-.56,0-.593,0l-.232.023.131.2a1.19,1.19,0,0,1,.161.614c0,.312.141,6.053.2,8.574l-.03.032c-.078.084-.159.168-.241.257l-.014.015a1.118,1.118,0,0,0-1.173.257l-1,1a1.108,1.108,0,0,0-.31.609l-7.943-.2a.722.722,0,0,0-.733.711v.023c0,.387,0,.56,0,.593l.023.232.2-.131a1.192,1.192,0,0,1,.615-.161c.265,0,4.47-.1,8.009-.189a3.593,3.593,0,0,0-.923,2.363L16.369,61.66l-1.717-.6-.619.618,1.422,1-1.817,2.008.686.684.1-.1.259-.258.1-.1-.209-.209L16.1,63.314l.993,1.422.62-.62-.6-1.717,4.277-3.869a3.651,3.651,0,0,0,2.407-.954,1.1,1.1,0,0,0,.107.069l-.2,8.072a.722.722,0,0,0,.711.733h.349c.165,0,.246,0,.269,0l.232-.023-.131-.2a1.179,1.179,0,0,1-.161-.614c0-.3-.128-5.516-.187-7.874a1.11,1.11,0,0,0,.459-.277l1-1a1.118,1.118,0,0,0,.257-1.173l.014-.014c.156-.142.3-.281.446-.418",
    transform: "translate(-5.29 -18.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    transform: "translate(10.785 45.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    d: "M16.732,79.878l-2.658,2.658.2.2,2.658-2.659-.1-.1Z",
    transform: "translate(-6.045 -34.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    d: "M65.633,85.376h-.005a2.838,2.838,0,0,0-2.73,2l-.869,0,.059-.568-.682-.685-.6.04,0-.887a2.855,2.855,0,0,0,1.148-.689h0a2.884,2.884,0,0,0-2.032-4.927h0a2.875,2.875,0,0,0-.824,5.635l-.007,2.071-2.078-.007a2.844,2.844,0,0,0-2.745-2.059h-.005a2.884,2.884,0,0,0,0,5.768h.005a2.847,2.847,0,0,0,2.731-2l1.313,0,.775.778,0,1.322a2.849,2.849,0,0,0-1.148.688,2.884,2.884,0,1,0,4.079.007,2.845,2.845,0,0,0-1.219-.713l.007-2.074,2.079.007a2.842,2.842,0,0,0,2.745,2.06h.005a2.884,2.884,0,0,0,0-5.769m-7.346-1.2a2.314,2.314,0,0,1,1.638-3.947h0a2.314,2.314,0,0,1,.885,4.45l.007-2.136-1.711-.006L59.1,84.7a2.3,2.3,0,0,1-.816-.524M55.9,89.816h0a2.294,2.294,0,0,1-1.632.675h0a2.314,2.314,0,0,1,0-4.627h0a2.3,2.3,0,0,1,2.152,1.487l-2.156-.007-.006,1.711,2.142.007a2.29,2.29,0,0,1-.5.754m5.708,2.45a2.314,2.314,0,0,1-1.638,3.947h0a2.311,2.311,0,0,1-.885-4.447L59.073,93.9l1.711.005.007-2.163a2.287,2.287,0,0,1,.816.524M67.261,89.9h0a2.294,2.294,0,0,1-1.632.675h0a2.3,2.3,0,0,1-2.152-1.488l2.156.007.005-1.711-2.141-.007a2.306,2.306,0,0,1,2.136-1.428h0A2.314,2.314,0,0,1,67.261,89.9",
    transform: "translate(-22.071 -34.214)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleet);
export default __webpack_public_path__ + "static/media/fleet.21250389a69c3ce5c198e06a9ddc248b.svg";
export { ForwardRef as ReactComponent };